<template>
  <section class="service-fomo">
    <img class="service-fomo__img" :src="icon" />
    <p><strong>You're only one step away from locking in your dumpster rental!</strong> That mess doesn't stand a chance.</p>
  </section>
</template>

<script>
import config from '@/config'
const { cdn } = config

export default {
  data () {
    return {
      icon: `${cdn}icons-clapping-FOMO.svg`
    }
  }
}
</script>
